import {
    FETCH_FAQS_REQUEST,
    FETCH_FAQS_SUCCESS,
    FETCH_FAQS_FAILURE,
} from "./types";

import {
    fetchFAQs,
} from "../../services/faqService";

export const fetchFAQsAction =
    () =>
    async (
        dispatch
    ) => {
        dispatch({
            type:
                FETCH_FAQS_REQUEST,
        });

        const result =
            await fetchFAQs();

        if (
            result.success
        ) {
            dispatch({
                type:
                    FETCH_FAQS_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    FETCH_FAQS_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };